import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from 'yup';
import { useToast } from "../../../Hooks/ToasContext";
import { ICategoryEntity, ICreateCategoryPayload, IUpdateCategoryPayload } from "../../../Services/api/categories/categories.interface";
import { CreateCategoriesUseCase } from "../../../Usecase/Categories/create-categories-usecase";
import { ShowCategoriesUseCase } from "../../../Usecase/Categories/show-categories-usecase";
import { UpdateCategoriesUseCase } from "../../../Usecase/Categories/update-categories-usecase";

interface IUseCreateCategoriesProps {
  createCategoriesUseCase: CreateCategoriesUseCase
  showCategoriesUseCase: ShowCategoriesUseCase
  updateCategoriesUseCase: UpdateCategoriesUseCase
}

const CreateCategorySchemaValidation = Yup.object().shape({
    code: Yup.string().required('Código é obrigatório'),
    width: Yup.string().required('Largura é obrigatório'),
    length: Yup.string().required('Comprimento é obrigatório'),
    height: Yup.string().required('Altura é obrigatório'),
  });


interface ICategoryProps {
	code: string
	width: number
	length: number
	height: number
}

const storeTypeOptions = [
  { label: 'Cadastrar na EMPO - B2B', value: 'createOnNSEmpo' },
  { label: 'Cadastrar na EMPO - B2C', value: 'createOnNSPapello' },
];


export function useCreateCategories({ createCategoriesUseCase, showCategoriesUseCase, updateCategoriesUseCase }: IUseCreateCategoriesProps){
    const [loading, setLoading] = useState(false)
    
    const [lengthValue, setLenghValue] = useState(0);
    const [widthValue, setWidthValue] = useState(0)
    const [heightValue, setHeightValue] = useState(0)
    const [data, setData] = useState<ICategoryEntity>()

    const params = useParams()
    
    const navigate = useNavigate()
    const { handleSubmit, register, control, formState, setValue } = useForm<ICreateCategoryPayload>({
        resolver: yupResolver(CreateCategorySchemaValidation),
      });

      const { errors } =  formState

    const { showToast } =  useToast()

    const listCategories = async (categoryId: string) => {
        
        try {
          setLoading(true)
          
          const showResult = await showCategoriesUseCase.handle(categoryId);

          if (showResult.isFailure) {
            showToast(String(showResult?.error?.error), 'error');
            return;
          }

         const box = showResult.getValue()

         if(box){
            setData(box)

            
         }

        } catch (error) {
          console.log("error listCategories function: ", error)
        } finally {
          setLoading(false);
        }
      };


    const handleAction: SubmitHandler<ICreateCategoryPayload> = async (values) => {
        console.log("values: ", values)
        try {
          setLoading(true)

          const payloadCreate: ICreateCategoryPayload  = {
            ...values
          }

          const payloadUpdate: IUpdateCategoryPayload  = {
            ...values,
            categoryId: String(params.id)
          }

          console.log("payloadUpdate: ", payloadUpdate)

        
          const storeResult = params.id ? await updateCategoriesUseCase.handle(payloadUpdate) :  await createCategoriesUseCase.handle(payloadCreate);

          if (storeResult.isFailure) {
            
            showToast(String(storeResult?.error?.error), 'error');
            return;
          }

          showToast(params.id ? 'Categoria Atualizada' : 'Categoria Cadastrada', 'success')
          navigate('/box-list');

        } catch (error) {
            console.log("error: ", error)
            showToast(error.response?.data?.error ?? 'Erro. Por favor, tente novamente', 'error');
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
        } finally {
          setLoading(false);
        }
      };

  
    useEffect(() => {
      if(params.id){
        listCategories(params.id)
      }
    },[])

      

    return {
        loading,
        handleSubmit,
        handleAction,
        register,
        lengthValue,
        setLenghValue,
        widthValue,
        setWidthValue,
        heightValue,
        setHeightValue,
        errors,
        data,
        storeTypeOptions,
        control
        
        
    }
}